module.exports = __webpack_public_path__ + "static/media/plus-square-white.133f01a0.svg";